import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { BankAccountService } from '../bancos/bankaccount.service';
import { BankAccountModel } from '../bancos/bankaccount.model';
import { consts } from '../../../consts';
import { CobroCuotasCreditosModel, CreditosModel } from './creditos.model';
import { CreditosListComponent } from './creditos-list.component';
import { CreditosService } from './creditos.service';
import { PreinvoiceService } from '../../invoice/preinvoice/preinvoice.service';
import { ActivityModel } from '../../user/activity/activity.model';
import { ActivityService } from '../../user/activity/activity.service';
import { MasterModel } from '../../../modules_v2/master/models/master.model';
import { MasterService } from '../../../modules_v2/master/services/master.service';
import { ActualSelected } from '../../../shared/utils';

@Component({
    selector: 'convfact-creditoscobrocuotas',
    templateUrl: './creditos-dialog-cobro-cuotas.component.html',
    styleUrls: ['./creditos.component.css'],
    standalone: false
})
export class CreditosDialogCobroCuotasComponent implements OnInit {

  public creditos: CreditosModel = this.data.creditos;

  public cobroCuotasCreditos: CobroCuotasCreditosModel = new CobroCuotasCreditosModel();

  public depositSaved: boolean = false;

  public ready: boolean = false;

  public isEditMode: boolean = false;

  public list: boolean = false;

  public bankAccounts: BankAccountModel[] = [];

  public dataSource: CobroCuotasCreditosModel[] = [];
  public headerTable: any[] = [
    { field: 'fecha', title: 'Fecha', cell: (row) => `${new Date(row.fecha).toLocaleDateString()}`, class: (row) => `` },
    { field: 'importeCapital', title: 'Importe Capital', cell: (row) => `${row.importeCapital}  `, class: (row) => `` },
    { field: 'intereses', title: 'Intereses', cell: (row) => `${row.intereses}  `, class: (row) => `` },
    { field: 'bankAccountInfo', title: 'Banco / Tarjeta', cell: (row) => row.bankAccountInfo ? `${row.bankAccountInfo}` : '', class: (row) => `` },
  ];

  public invalidDate: boolean = false;
  public invalidConcept: boolean = false;
  public invalidImporteCapital: boolean = false;
  public invalidIntereses: boolean = false;
  public invalidBankAccount: boolean = false;

  public taxes: any[] = [];

  public activities: ActivityModel[] = [];

  projects: MasterModel[] = [];
  expenseProjectTypes: MasterModel[] = [];
  isProjectEnable: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CreditosListComponent>,
    private preinvoiceService: PreinvoiceService, // Only for obtain taxes
    public creditosService: CreditosService,
    public bankAccountService: BankAccountService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public activityService: ActivityService,
    private cdr: ChangeDetectorRef,
    private masterService: MasterService,
  ) { }

  ngOnInit(): void {
    this.ready = false;

    // Actividades
    this.activityService.getList().then(res => {
      this.activities = res;
      if (this.activities.length === 1) this.cobroCuotasCreditos.activitiesUid = this.activities[0].uid;
    });
    this.activityService.loadData(ActualSelected.activitySelected).then(activity => {
          this.isProjectEnable = activity.isProject;
        });

    // Bancos
    this.bankAccountService.getList().then(res => this.bankAccounts = res.list);

    // Impuestos
    this.preinvoiceService.accountsAndTaxesData()
      .then(data => this.taxes = data.taxes.filter(x => x.name === 'IRPF 19% Cesión a terceros de capitales propios'));

    // Proyectos
    this.masterService.getProjects().subscribe(data => {
      this.projects = data;
      this.cdr.detectChanges();
    });
    this.masterService.getExpenseProjectTypes().subscribe(data => {
      this.expenseProjectTypes = data;
      this.cdr.detectChanges();
    });

    this.getData();
  }

  pay(): void {
    this.cobroCuotasCreditos.creditosId = this.creditos.uid;

    let noError = true;

    if (!this.cobroCuotasCreditos.fecha) { noError = false; this.invalidDate = true; }
    if (!this.cobroCuotasCreditos.concepto || this.cobroCuotasCreditos.concepto.trim() === '') {
      noError = false;
      this.invalidConcept = true;
    }

    if (!this.cobroCuotasCreditos.importeCapital || this.cobroCuotasCreditos.importeCapital <= 0) { noError = false; this.invalidImporteCapital = true; }
    if (!this.cobroCuotasCreditos.bankAccountsUid || this.cobroCuotasCreditos.bankAccountsUid === consts.EMPTY_GUID) { noError = false; this.invalidBankAccount = true; }
    if (!this.cobroCuotasCreditos.activitiesUid) { noError = false; }

    // Validación de project y expense en el propio cobro
    // if (!this.cobroCuotasCreditos.projectUid || this.cobroCuotasCreditos.projectUid === consts.EMPTY_GUID) { noError = false; this.displayInfo("Debe seleccionar un proyecto"); }
    // if (!this.cobroCuotasCreditos.expenseProjectTypeUid || this.cobroCuotasCreditos.expenseProjectTypeUid === consts.EMPTY_GUID) { noError = false; this.displayInfo("Debe seleccionar un tipo de gasto del proyecto"); }

    if (!noError) { this.displayInfo("Compruebe que tiene los campos rellenados correctamente"); return; }

    const request = this.isEditMode
      ? this.creditosService.cobroCoutasUpdate(this.cobroCuotasCreditos)
      : this.creditosService.cobroCoutasCreate(this.cobroCuotasCreditos);

    request
      .then(() => { this.depositSaved = true; this.getData(); })
      .catch(() => this.displayInfo("Ha ocurrido un error al guardar el cobro"));
  }

  getData(): void {
    this.depositSaved = false;
    this.ready = false;

    this.invalidDate = false;
    this.invalidConcept = false;
    this.invalidImporteCapital = false;
    this.invalidIntereses = false;
    this.invalidBankAccount = false;

    this.creditosService.cobroCoutasList(this.creditos.uid)
      .then(res => {
        this.dataSource = res;
        this.list = this.dataSource.length > 0;
        this.ready = true;
      })
      .catch(() => this.ready = true);
  }

  edit(uid: string): void {
    const element = this.dataSource.find(f => f.uid === uid);
    if (element) {
      this.isEditMode = true;
      this.depositSaved = false;
      this.cobroCuotasCreditos = { ...element };
    }
  }

  delete(uid: string): void {
    this.creditosService.cobroCoutasDelete(uid)
      .then(() => this.getData())
      .catch(() => this.displayInfo("Ha ocurrido un error al eliminar el Cobro"));
  }

  displayInfo(msg: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container'];
    this.snackBar.open(msg, '', options);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
  public trackByIndex(i: number) { return i; }

}
